import layerCssClasses from 'bloko/common/constants/layersCssClasses';
import media from 'bloko/common/media';
import Metrics from 'bloko/common/metrics';

export const PLACEMENTS = {
    topStart: 'top-start',
    top: 'top',
    topEnd: 'top-end',
    rightStart: 'right-start',
    right: 'right',
    rightEnd: 'right-end',
    bottomStart: 'bottom-start',
    bottom: 'bottom',
    bottomEnd: 'bottom-end',
    leftStart: 'left-start',
    left: 'left',
    leftEnd: 'left-end',
};

// Охранная область от границ view port
export const GUARD_SIZE = 15;

export const FLEXIBLE_CLASS = 'bloko-drop_flexible';

export const MIN_SIZE_TO_PLACE_DROP_AT_THE_START = 50;
export const OFFSET_TO_ARROW_X = 25;
export const OFFSET_TO_ARROW_Y = 21;
export const DIRECTION_MAPPING = {
    x: ['left', 'right'],
    y: ['top', 'bottom'],
};
export const OPPOSITE_DIRECTIONS = [DIRECTION_MAPPING.x, DIRECTION_MAPPING.y];

export const DISTANCE = 5;
export const LAYER_CLASSES = Object.keys(layerCssClasses).reduce((result, item) => {
    result[item] = `bloko-drop_layer-${layerCssClasses[item]}`;
    return result;
}, {});

export const LAYERS = Object.keys(layerCssClasses).reduce((result, item) => {
    result[item] = item;
    return result;
}, {});

export const ANIMATION_TIMEOUT_MS = 32;
export const ENTER_ANIMATION_MS = 300;
export const ARROW_SIZE = 5;

export const PLACEMENT_DOWN_SEQUENCE = [
    PLACEMENTS.bottomStart,
    PLACEMENTS.bottomEnd,
    PLACEMENTS.topStart,
    PLACEMENTS.topEnd,
    PLACEMENTS.rightStart,
    PLACEMENTS.rightEnd,
    PLACEMENTS.leftEnd,
    PLACEMENTS.leftStart,
];

export const DOWN_PLACEMENTS = Object.entries(PLACEMENTS)
    .filter(([, value]) => PLACEMENT_DOWN_SEQUENCE.includes(value))
    .reduce((acc, [key, value]) => {
        acc[key] = value;
        return acc;
    }, {});

// если хост не боди, то мы должны вручную установить размеры для меню, с учетом скроллбаров
export function setupWidth(node, host) {
    if (
        media.getBreakpoint() === media.breakpoint.XS &&
        host !== document.body &&
        document.querySelector('.xs-friendly')
    ) {
        node.style.width = '';
        node.style.width = `${window.innerWidth - Metrics.getScrollbarWidth()}px`;
    } else {
        node.style.width = '';
    }
}
